import type { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { HeaderPage } from 'components/header/HeaderPage';
import { Tabs } from 'enable-ui';

import { DashboardWrapper } from '../styles/dashboard';

import { useContentController } from '../core/controller/content';
import { getTabs } from '../core/tabs';

export const DashboardLayout: FC<{ hideAddButton?: boolean }> = ({ hideAddButton }) => {
  const items = getTabs();

  const { onTabClick, onClickAddItem, locationPath } = useContentController();

  return (
    <DashboardWrapper className="full-width">
      <HeaderPage title="Library" onClick={onClickAddItem} hideButton={hideAddButton} />

      <Tabs
        variant="text"
        items={items}
        activeKey={locationPath}
        onTabClick={onTabClick}
        tabItemStyle={{
          height: 44,
          background: 'transparent',
          fontSize: '18px',
          lineHeight: '26px',
          fontWeight: 600,
        }}
        isLine={true}
      />
      <div style={{ paddingTop: 16 }}>
        <Outlet />
      </div>
    </DashboardWrapper>
  );
};
